import React, {Component} from 'react';
import Header from '../elements/Header';
import NextStep from '../elements/NextStep';
import PropTypes from 'prop-types';
import { __, __n } from 'i18n-for-browser';

import connect from "react-redux/es/connect/connect";
import ListButton from "../elements/ListButton";
import QuestionButton from "../elements/QuestionButton";
import ContentContainer from "../elements/ContentContainer";
import IncomeDetail from "../elements/IncomeDetail";
import TaxItemContainer from "../elements/TaxItemContainer";
import TaxItem from "../elements/TaxItem";
import TaxesLow from "../elements/TaxesLow";
import { checkRead, getText, getImageText, getImage, getPoints, getOverigeInkomsten, calculateDebitCreditOutcome } from "../../helpers/feedbackHelpers";
import {dispatchUnreadPopup, getContent} from "../../helpers/popupHelper";

/**
 * Import assets
 */
import Economy from "../../assets/img/icons/economy/economy.svg";
import Buitenland from "../../assets/img/icons/buitenland.svg";
import Belasting1 from "../../assets/img/icons/belasting-1.svg";
import Belasting2 from "../../assets/img/icons/belasting-2.svg";
import Belasting3 from "../../assets/img/icons/belasting-3.svg";
import Belasting4 from "../../assets/img/icons/belasting-4.svg";
import Belasting5 from "../../assets/img/icons/belasting-5.svg";
import Belasting6 from "../../assets/img/icons/belasting-6.svg";
import Belasting7 from "../../assets/img/icons/belasting-7.svg";
import VerliesGlobas from "../../assets/img/icons/economy/min-globas.svg";
import WinstGlobas from "../../assets/img/icons/economy/up-globas.svg";
import Warning from "../../assets/img/icons/warning.svg";
import Budget from "../../assets/img/icons/budget.png";
import { ministryIcons } from '../../assets/assets';
import PopupTitle from "../elements/PopupTitle";

import actions from '../../actions';
import config from '../../config';

const { updateMyState } = actions.gameStateInput;

class Taxes extends Component {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  };
  static defaultProps = {
    desktop: false
  };
  constructor(props) {
    super(props);
    this.state = {
      showOtherIncomeDropdown: false,
      showBuitenlandDropdown: false,
      showInterestDropdown: false,
      showBudgetDropdown: false,
      openedVBelasting: false,
    };
  }

  setShown = () => {
    this.setState({
      openedVBelasting: true,
    });
  }

  componentDidMount(){
    const { gameState, dispatch, project } = this.props;
    if(gameState.currentRound === 1 && gameState.currentStep === 2){
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhgvtbelastingheffen_T1' : 'mlgvtbelastingheffen1_T1'), dispatch);
    }
    if(gameState.currentRound === 2 && gameState.currentStep === 2){
      if(project.difficulty === "BASIC") {
        dispatchUnreadPopup('mlgvtbelastingheffen2_T1', dispatch);
      }
    }
  }

  toggleOther(property) {
    const state = { ...this.state };
    state[property] = !state[property];
    this.setState(state);
  }

  getGroupIcons = (groups = []) => {
    const { schoolClass } = this.props;
    return groups.map((grp, i) => {
      const g = schoolClass.Groups.find(g => g.GroupTheme.color === grp);
      if (g) return <img key={Math.random() + i + 'lolimsorandom'} className={'tax-item-badge'} src={`${config.apiUrl}${g.GroupTheme.badge}`} alt={'badge'} />;
      return null;
    });
  };

  validateTaxOne = () => {
    const { gameStateInput: { myState: state } } = this.props;
    const ab = state.arbeidsBelasting >= 1 && state.arbeidsBelasting <= 59;
    const bb = state.bedrijvenBelasting >= 1 && state.bedrijvenBelasting <= 34;
    return ab && bb;
  };

  validateTaxTwo = () => {
    const vSeen = this.state.openedVBelasting;
    const { gameStateInput: { myState: state } } = this.props;
    const c = state.CBelasting >= 1 && state.CBelasting <= 34;
    const vv = state.VVBelasting >= 1 && state.VVBelasting <= 49;
    const v = state.VBelasting >= 0 && state.VBelasting <= 6;
    return c && vv && (vSeen && v);
  };

  getWinstVerliesEffect = fb => ({
    icon: parseInt(fb.winstverliesglobas, 10) >= 0 ? WinstGlobas : VerliesGlobas,
    title: parseInt(fb.winstverliesglobas, 10) >= 0 ? __('sim_winstglobas') : __('sim_verliesglobas'),
    contentTitle: fb.winstverliesglobas || 0,
    contentUnit: __('sim_miljard'),
  });

  getTotalBuitenland = (state) => {
    return state.BL_AB_globas + state.BL_BB_globas + state.BL_CB_globas + state.BL_VVB_globas + state.BL_VB_globas;
  };

  getTotalBudgetPoints = (state) => {
    return state.AB_points + state.BB_points + state.VV_points + state.C_points + state.V_points;
  };

  getTotalBudgetGlobas = (state, oi, totalDebitCredit) => {
    return state.AB_globas + state.BB_globas + state.VV_globas + state.C_globas + state.V_globas + this.getOISum(oi) + totalDebitCredit;
  };

  getEffects = fb => {
    const effects = [];
    if (fb.economie) {
      effects.push(this.getWinstVerliesEffect(fb.economie));
    }
    return effects.concat(fb.overigeEffecten.map((oe) => ({
      icon: ministryIcons[oe.ministerie],
      title: __(oe.ministerie),
      contentTitle: getPoints(oe),
      contentUnit: __('sim_punten'),
    })));
  };

  getOISum = (overigeInkomsten, replacementChar) => overigeInkomsten.reduce((sum, oi) => {
    sum += parseInt(oi.winstverliesglobas, 10) || 0;
    return sum;
  }, 0) || (replacementChar || 0);

  render() {
    const {
      gameState, gameStateInput, feedback, dispatch, desktop
    } = this.props;

    const { myState } = gameStateInput;
    const {
      gameStateSum, gameStateInput: roundGameStateInput, state: currentState, roundNumber,
    } = gameState.roundData;
    const {
      feedbackAB, feedbackBB, feedbackCB, feedbackVVB, feedbackVB,
    } = feedback;
    const overigeInkomsten = getOverigeInkomsten(feedback.prevRoundFeedbackData, gameState);
    if (this.props.project.difficulty === 'BASIC') {
      return (
        <TaxesLow
          desktop={this.props.desktop}
          history={this.props.history}
          inheritedState={this.state}
          getGroupIcons={this.getGroupIcons}
        />
      );
    }
    let isBankDisabledForSimulation = false;
    if (this.props.gameStateInput && this.props.gameStateInput.myState && this.props.gameStateInput.myState.SIMULATION_TAX === 'PROCESSED') {
      const currDC = this.props.gameState.roundData && this.props.gameState.roundData.lastGameState && this.props.gameState.roundData.lastGameState.OneTimeEffect && this.props.gameState.roundData.lastGameState.OneTimeEffect.debitCredit;
      isBankDisabledForSimulation = currDC ? currDC.some(c => c.bankDisabledPayout) : false;
    } else {
      isBankDisabledForSimulation = this.props.project.bankEnabled === false;
    }

    const debitCredit = this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit
      .filter(dc => !dc.key.endsWith('NotConfirmed'))
      .map(dbCr => calculateDebitCreditOutcome(dbCr, roundNumber, isBankDisabledForSimulation))
      .filter(entry => entry && entry.amount); //filter out empty
    const totalDebitCredit = debitCredit.reduce((acc,val) => acc-val.amount, 0);

    let {AB_economie, BB_economie} = gameStateSum;
    AB_economie = AB_economie  || Math.round(gameState.totalEconomy * myState.taxDividence);
    BB_economie = BB_economie || (gameState.totalEconomy - AB_economie);

    const buitenland1 = gameStateSum.BL_AB_globas + gameStateSum.BL_BB_globas;
    const buitenland2 = gameStateSum.BL_VVB_globas + gameStateSum.BL_CB_globas + gameStateSum.BL_VB_globas;

    const taxAVideo = gameState.language === 'NL' ? `${config.uploadsUrl}/assets/videos/belasting_HOOGA_NL_720p_1,5Mbps.mp4` : `${config.uploadsUrl}/assets/videos/belasting_HOOGA_ENG_720p_1,5Mbps.mp4`;
    const taxBVideo = gameState.language === 'NL' ? `${config.uploadsUrl}/assets/videos/belasting_HOOGB_NL_720p_1,5Mbps.mp4` : `${config.uploadsUrl}/assets/videos/belasting_HOOGB_ENG_720p_1,5Mbps.mp4`;

    return (
      <div>
        {
          !desktop ? (
            <Header match={this.props.match} history={this.props.history} historic={false} buttonType='view' viewType='list' showTitle={true}/>
          ) : null
        }
        <div className='container taxes'>
          <PopupTitle popupId={'mhgvteconomie'} tag={'h3'}/>

          <ListButton
            reverseGlobasPoints={true}
            bgColor='darkblue'
            title={__('sim_totalglobas')}
            icon={Economy}
            globas={gameState.totalEconomy}
            hidePoints={true}
          />
          {
            gameState.prevRoundSum.FB_value <= 0
            ? (
                <div className={'warning-element content-container'}>
                  <div className='content-container-background'/>
                  <span>
                    <img src={Warning} alt="warning"/>
                    <p dangerouslySetInnerHTML={{__html: getContent("dhgmstap2fb0", gameState.language)}} />
                  </span>
                </div>
              )
            : null
          }
          {
            myState.SIMULATION_TAX === 'PROCESSED' && (buitenland1 + buitenland2) > 0
            ? (
                <div className={'taxes-section'}>
                  <h3><QuestionButton popupid="dhgvtbuitenland">{__('sim_buitenland')}</QuestionButton></h3>
                  <ListButton feedbackCount={myState.buitenlandRead ? 0 : 1} onClick={() => {
                    if (!myState.buitenlandRead) {
                      dispatch(updateMyState({ buitenlandRead: true }));
                    }
                    this.toggleOther('showBuitenlandDropdown');
                  }} bgColor='darkblue' title={__('sim_buitenland')} icon={Buitenland} globas={this.getTotalBuitenland(gameStateSum)} hidePoints={true}/>

                  <div className={'buitenland interest-income country-budget' + (this.state.showBuitenlandDropdown ? ' active' : '')}>
                    <ContentContainer>
                      <h4>{__('sim_verplaats_naar_buitenland')}</h4>
                      <br/>
                      <div className={'table-interest'}>
                        <div><p>{__('sim_lonen_werknemers')}</p></div>
                        <div><p/></div>
                        <div><p>{gameStateSum.BL_AB_globas} {__('sim_miljard')}</p></div>
                      </div>
                      <div className={'table-interest'}>
                        <div><p>{__('sim_winsten_bedrijfseigenaren')}</p></div>
                        <div><p/></div>
                        <div><p>{gameStateSum.BL_BB_globas} {__('sim_miljard')}</p></div>
                      </div>
                      <div className={'table-interest'}>
                        <div><p>{__('sim_consumptie')}</p></div>
                        <div><p/></div>
                        <div><p>{gameStateSum.BL_CB_globas} {__('sim_miljard')}</p></div>
                      </div>
                      <div className={'table-interest'}>
                        <div><p>{__('sim_consumptie_schadelijke_producten')}</p></div>
                        <div><p/></div>
                        <div><p>{gameStateSum.BL_VVB_globas} {__('sim_miljard')}</p></div>
                      </div>
                      <div className={'table-interest'}>
                        <div><p>{__('sim_spaargeld_en_beleggingen')}</p></div>
                        <div><p/></div>
                        <div><p>{gameStateSum.BL_VB_globas} {__('sim_miljard')}</p></div>
                      </div>
                      <div className={'plus-minus'}/>
                      <div className={'table-interest bold'}>
                        <div><p>{__('sim_totaal')}</p></div>
                        <div><p/></div>
                        <div><p>{this.getTotalBuitenland(gameStateSum)} {__('sim_miljard')}</p></div>
                      </div>
                    </ContentContainer>
                  </div>
                </div>
              )
            : null
          }

          {/* Tax step 1 */}
          <TaxItemContainer
            title={__('sim_belastingen')}
            buttonConditions={this.validateTaxOne()}
            video={taxAVideo}
            saving={myState.SIMULATION_TAX === 'SUBMITTED'}
            saved={myState.SIMULATION_TAX === 'PROCESSED'}
            showSavedPopup={myState.showSavedPopup === 'SIMULATION_TAX'}
            buitenLandDialog={buitenland1}
            visible={true}
            step={'SIMULATION_TAX'}
            savingMessage={'dhgmstap2opslaan1'}
            feedbackMessage={'dhgmstap2opslaan1_2'}
            part={1}
            popupId={'mhgvtbelastingendeel1'}
          >
            <TaxItem
              title={__('sim_arbeidsbelasting')}
              video={'https://player.vimeo.com/video/265045525'}
              sliderKey={'arbeidsBelasting'}
              points={myState.SIMULATION_TAX !== 'PROCESSED' ? '-' : gameStateSum.AB_points}
              globas={myState.SIMULATION_TAX !== 'PROCESSED' ? '-' : gameStateSum.AB_globas}
              saving={myState.SIMULATION_TAX === 'SUBMITTED'}
              maxValue={100}
              cap={59}
              minValue={1}
              capNotification={__('sim_arbeidsbelasting_te_hoog_percentage_melding')}
              type={'taxSlider'}
              suffix={'%'}
              sliderValue={myState.arbeidsBelasting}
              collaborationValue={myState.samenWerkingAB}
              collaborationKey={'samenWerkingAB'}
              notification={{
                read: feedbackAB.read,
                reference: feedbackAB.id,
              }}
              icon={Belasting1}
              dataList={[{ title: __('sim_lonenwerknemers'), globas: AB_economie }]}
              feedbackData={{
                show: myState.SIMULATION_TAX === 'PROCESSED',
                topData: [{
                  title: __('sim_lonen_werknemers'),
                  value: `${AB_economie} ${__('sim_miljard')}`,
                },{
                  title: __('sim_gekozen_belastingspercentage'),
                  value: `${(roundGameStateInput || {}).arbeidsBelasting} ${__n('sim_procent', 1).toLowerCase()}`,
                },{
                  title: __('sim_samenwerkingmetanderelanden'),
                  value: this.getGroupIcons(myState.collaborationMatches.samenWerkingAB)
                },{
                  title: __('sim_verplaatst_naar_buitenland'),
                  hideWhenZero: true,
                  value: `${gameStateSum.BL_AB_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_geinde_arbeidsbelasting'),
                  value: `${gameStateSum.AB_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_besteedbaar_inkomen_werknemers'),
                  value: `${AB_economie - gameStateSum.BL_AB_globas - gameStateSum.AB_globas} ${__('sim_miljard')}`,
                }],
                img: getImage(feedbackAB),
                imgDescription: getImageText(feedbackAB, gameState.language),
                description: getText(feedbackAB, gameState.language),
                effects: this.getEffects(feedbackAB),
              }}
              popupId={'mhgvtarbeidsbelasting'}
            />
            <TaxItem
              title={__('sim_bedrijvenbelasting')}
              sliderKey={'bedrijvenBelasting'}
              points={myState.SIMULATION_TAX !== 'PROCESSED' ? '-' : gameStateSum.BB_points}
              globas={myState.SIMULATION_TAX !== 'PROCESSED' ? '-' : gameStateSum.BB_globas}
              saving={myState.SIMULATION_TAX === 'SUBMITTED'}
              maxValue={100}
              cap={34}
              minValue={1}
              capNotification={__('sim_bedrijvenbelasting_te_hoog_percentage_melding')}
              type={'taxSlider'}
              suffix={'%'}
              sliderValue={myState.bedrijvenBelasting}
              collaborationValue={myState.samenWerkingBB}
              collaborationKey={'samenWerkingBB'}
              notification={{
                read: feedbackBB.read,
                reference: feedbackBB.id,
              }}
              icon={Belasting2}
              dataList={[{ title: __('sim_winsten_bedrijfseigenaren'), globas: BB_economie }]}
              feedbackData={{
                show: myState.SIMULATION_TAX === 'PROCESSED',
                topData: [{
                  title: __('sim_winsten_bedrijfseigenaren'),
                  value: `${BB_economie} ${__('sim_miljard')}`
                },{
                  title: __('sim_gekozen_belastingspercentage'),
                  value: `${(roundGameStateInput || {}).bedrijvenBelasting} ${__n('sim_procent', 1).toLowerCase()}`
                },{
                  title: __('sim_samenwerkingmetanderelanden'),
                  value: this.getGroupIcons(myState.collaborationMatches.samenWerkingBB)
                },{
                  title: __('sim_verplaatst_naar_buitenland'),
                  hideWhenZero: true,
                  value: `${gameStateSum.BL_BB_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_geinde_bedrijvenbelasting'),
                  value: `${gameStateSum.BB_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_besteedbaar_inkomen_bedrijfseigenaren'),
                  value: `${BB_economie - gameStateSum.BL_BB_globas - gameStateSum.BB_globas} ${__('sim_miljard')}`,
                }],
                img: getImage(feedbackBB),
                imgDescription: getImageText(feedbackBB, gameState.language),
                description: getText(feedbackBB, gameState.language),
                effects: this.getEffects(feedbackBB),
              }}
              popupId={'mhgvtbedrijvenbelasting'}
            />
          </TaxItemContainer>

          {/* Tax step 2 */}
          <TaxItemContainer
            title={__('sim_belastingen')}
            buttonConditions={this.validateTaxTwo()}
            video={taxBVideo}
            saving={myState.SIMULATION_TAX_2 === 'SUBMITTED'}
            saved={myState.SIMULATION_TAX_2 === 'PROCESSED'}
            showSavedPopup={myState.showSavedPopup === 'SIMULATION_TAX_2'}
            buitenLandDialog={(!buitenland1 && buitenland2) ? buitenland2 : false}
            visible={[
              'SIMULATION_TAX_2',
              'SIMULATION_SPENDING',
              'END',
            ].includes(currentState) && checkRead(feedbackAB, false, 0, false) && checkRead(feedbackBB, false, 0, false)}
            step={'SIMULATION_TAX_2'}
            savingMessage={'dhgmstap2opslaan2'}
            feedbackMessage={'dhgmstap2opslaan2_2'}
            part={2}
            popupId={'mhgvtbelastingendeel2'}
          >
            <TaxItem
              title={__('sim_consumentenbelasting')}
              video={'https://player.vimeo.com/video/265045525'}
              sliderKey={'CBelasting'}
              points={myState.SIMULATION_TAX_2 !== 'PROCESSED' ? '-' : gameStateSum.C_points}
              globas={myState.SIMULATION_TAX_2 !== 'PROCESSED' ? '-' : gameStateSum.C_globas}
              saving={myState.SIMULATION_TAX_2 === 'SUBMITTED'}
              maxValue={100}
              cap={34}
              minValue={1}
              capNotification={__('sim_consumentenbelasting_te_hoog_percentage_melding')}
              type={'taxSlider'}
              suffix={'%'}
              sliderValue={myState.CBelasting}
              collaborationValue={myState.CBelastingSW}
              collaborationKey={'CBelastingSW'}
              icon={Belasting3}
              notification={{
                read: feedbackCB.read,
                reference: feedbackCB.id,
              }}
              dataList={[{ title: __('sim_consumptie'), globas: gameState.roundData.lastGameState.OneTimeEffect.CO }]}
              feedbackData={{
                show: myState.SIMULATION_TAX_2 === 'PROCESSED',
                topData: [{
                  title: __('sim_consumptie'),
                  value: `${gameState.roundData.gameStateSum.CO_value} ${__('sim_miljard')}`,
                },{
                  title: __('sim_gekozen_belastingspercentage'),
                  value: `${(roundGameStateInput || {}).CBelasting} ${__n('sim_procent', 1).toLowerCase()}`,
                },{
                  title: __('sim_samenwerkingmetanderelanden'),
                  value: this.getGroupIcons(myState.collaborationMatches.CBelastingSW)
                },{
                  title: __('sim_verplaatst_naar_buitenland'),
                  hideWhenZero: true,
                  value: `${gameStateSum.BL_CB_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_geinde_consumentenbelasting'),
                  value: `${gameStateSum.C_globas} ${__('sim_miljard')}`,
                }],
                img: getImage(feedbackCB),
                imgDescription: getImageText(feedbackCB, gameState.language),
                description: getText(feedbackCB, gameState.language),
                // TODO: multilanguage and niveau based and icons??
                effects: this.getEffects(feedbackCB)
              }}
              popupId={'mhgvtconsumentenbelasting'}
            />
            <TaxItem
              title={__('sim_mensmilieubelasting')}
              video={'https://player.vimeo.com/video/265045525'}
              sliderKey={'VVBelasting'}
              points={myState.SIMULATION_TAX_2 !== 'PROCESSED' ? '-' : gameStateSum.VV_points}
              globas={myState.SIMULATION_TAX_2 !== 'PROCESSED' ? '-' : gameStateSum.VV_globas}
              saving={myState.SIMULATION_TAX_2 === 'SUBMITTED'}
              maxValue={100}
              cap={49}
              minValue={1}
              capNotification={__('sim_mensmilieubelasting_te_hoog_percentage_melding')}
              type={'taxSlider'}
              suffix={'%'}
              sliderValue={myState.VVBelasting}
              collaborationValue={myState.VVBelastingSW}
              collaborationKey={'VVBelastingSW'}
              icon={Belasting4}
              notification={{
                read: feedbackVVB.read,
                reference: feedbackVVB.id,
              }}
              feedbackData={{
                show: myState.SIMULATION_TAX_2 === 'PROCESSED',
                topData: [{
                  title: __('sim_consumptie_schadelijke_producten'),
                  value: `${gameState.roundData.gameStateSum.VV_value} ${__('sim_miljard')}`,
                },{
                  title: __('sim_gekozen_belastingspercentage'),
                  value: `${(roundGameStateInput || {}).VVBelasting} ${__n('sim_procent', 1).toLowerCase()}`,
                },{
                  title: __('sim_samenwerkingmetanderelanden'),
                  value: this.getGroupIcons(myState.collaborationMatches.VVBelastingSW)
                },{
                  title: __('sim_verplaatst_naar_buitenland'),
                  hideWhenZero: true,
                  value: `${gameStateSum.BL_VVB_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_geinde_vervuilingsbelasting'),
                  value: `${gameStateSum.VV_globas} ${__('sim_miljard')}`,
                }],
                img: getImage(feedbackVVB),
                imgDescription: getImageText(feedbackVVB, gameState.language),
                description: getText(feedbackVVB, gameState.language),
                // TODO: multilanguage and niveau based and icons??
                effects: this.getEffects(feedbackVVB),
              }}
              dataList={[{ title: __('sim_consumptie_schadelijke_producten'), globas: gameState.roundData.lastGameState.OneTimeEffect.VV }]}
              popupId={'mhgvtmensenmilieubelasting'}
            />
            <TaxItem
              title={__('sim_vermogenbelasting')}
              video={'https://player.vimeo.com/video/265045525'}
              sliderKey={'VBelasting'}
              points={myState.SIMULATION_TAX_2 !== 'PROCESSED' ? '-' : gameStateSum.V_points}
              globas={myState.SIMULATION_TAX_2 !== 'PROCESSED' ? '-' : gameStateSum.V_globas}
              saving={myState.SIMULATION_TAX_2 === 'SUBMITTED'}
              maxValue={100}
              cap={6}
              minValue={0}
              registerShown={this.setShown}
              capNotification={__('sim_vermogensbelasting_te_hoog_percentage_melding')}
              type={'taxSlider'}
              suffix={'%'}
              sliderValue={myState.VBelasting}
              collaborationValue={myState.VBelastingSW}
              collaborationKey={'VBelastingSW'}
              icon={Belasting5}
              notification={{
                read: feedbackVB.read,
                reference: feedbackVB.id,
              }}
              feedbackData={{
                show: myState.SIMULATION_TAX_2 === 'PROCESSED',
                topData: [{
                  title: __('sim_totale_vermogen_van_burgers'),
                  value: `${gameState.totalGameStateSum.V_value + gameStateSum.V_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_gekozen_belastingspercentage'),
                  value: `${(roundGameStateInput || {}).VBelasting} ${__n('sim_procent', 1).toLowerCase()}`,
                },{
                  title: __('sim_samenwerkingmetanderelanden'),
                  value: this.getGroupIcons(myState.collaborationMatches.VBelastingSW)
                },{
                  title: __('sim_verplaatst_naar_buitenland'),
                  hideWhenZero: true,
                  value: `${gameStateSum.BL_VB_globas} ${__('sim_miljard')}`,
                },{
                  title: __('sim_geinde_vermogensbelasting'),
                  value: `${gameStateSum.V_globas} ${__('sim_miljard')}`,
                }],
                img: getImage(feedbackVB),
                imgDescription: getImageText(feedbackVB, gameState.language),
                description: getText(feedbackVB, gameState.language),
                // TODO: multilanguage and niveau based and icons??
                effects: this.getEffects(feedbackVB),
              }}
              dataList={[
                { title: __('sim_besparingen_deze_periode'), globas: gameState.roundData.gameStateSum.V_value },
                { title: __('sim_totale_vermogen_van_burgers'), globas: gameState.totalGameStateSum.V_value },
              ]}
              popupId={'mhgvtvermogensbelasting'}
            />
          </TaxItemContainer>

          <div className={'taxes-section overige-inkomsten'}>
            <PopupTitle popupId={'mhgvtoverigeinkomsten'} tag={'h3'}/>
            <ListButton onClick={this.toggleOther.bind(this, 'showOtherIncomeDropdown')} bgColor='white' title={__("sim_overige_inkomsten")} icon={Belasting6} globas={this.getOISum(overigeInkomsten, '-')} hidePoints={true} arrow={true}/>
            <div className={'other-income' + (this.state.showOtherIncomeDropdown ? ' active' : '')}>
              <ContentContainer>
                {overigeInkomsten.map((oi, i) =>
                  <IncomeDetail
                    key={i}
                    img={oi.icon}
                    title={oi.title}
                    description={getText(oi, gameState.language)}
                    amount={oi.winstverliesglobas}
                    unit={__('sim_miljard')}/>
                )}
              </ContentContainer>
            </div>
            {debitCredit.length?(
              <div>
                <ListButton onClick={this.toggleOther.bind(this, 'showInterestDropdown')} bgColor='white' title={__('sim_aflossingen_en_rentes')} icon={Belasting7} globas={totalDebitCredit} hidePoints={true} arrow={true}/>
                <div className={'interest-income' + (this.state.showInterestDropdown ? ' active' : '')}>
                  <ContentContainer>
                    {debitCredit.map((item, index) =>
                      <div className={'table-interest'} key={index}>
                        <div className={'img-container'}>
                          <img src={item.icon} alt={'icon'}/>
                        </div>
                        <p>{item.title}</p>
                        <p>{(-item.amount > 0 ? '+' + -item.amount : -item.amount)} {__('sim_miljard')} {__('sim_miljard')}</p>
                      </div>
                    )}
                    <div className={'plus-minus'}/>
                    <div className={'table-interest bold'}>
                      <p>{__('sim_totaal')}</p>
                      <p>{totalDebitCredit} {__('sim_miljard')}</p>
                    </div>
                  </ContentContainer>
                </div>
              </div>
              ):
              ''
            }
          </div>
          <div className="plus-minus">
            <span className="plus"/>
          </div>
          <div className={'taxes-section'}>
            <PopupTitle popupId={'mhgvtoverheidsbudget'} tag={'h3'}/>
            <ListButton reverseGlobasPoints onClick={this.toggleOther.bind(this, 'showBudgetDropdown')} bgColor='white' title={__('sim_overheidsbudget')} icon={Budget} globas={this.getTotalBudgetGlobas(gameStateSum, overigeInkomsten, totalDebitCredit)} points={myState.SIMULATION_TAX !== 'PROCESSED' ? '-' : this.getTotalBudgetPoints(gameStateSum)} bigArrow={true}/>
            <div className={'interest-income country-budget' + (this.state.showBudgetDropdown ? ' active' : '')}>
              <ContentContainer>
                {gameStateSum.AB_point  || gameStateSum.AB_globas ? (
                  <div className={'table-interest'}>
                    <div><p>{__('sim_arbeidsbelasting')}</p></div>
                    <div><p>{gameStateSum.AB_points} {__('sim_punten')}</p></div>
                    <div><p>{gameStateSum.AB_globas} {__('sim_miljard')}</p></div>
                  </div>
                ) : null}
                {gameStateSum.BB_points || gameStateSum.BB_globas ? (
                  <div className={'table-interest'}>
                    <div><p>{__('sim_bedrijvenbelasting')}</p></div>
                    <div><p>{gameStateSum.BB_points} {__('sim_punten')}</p></div>
                    <div><p>{gameStateSum.BB_globas} {__('sim_miljard')}</p></div>
                  </div>
                ) : null}
                {gameStateSum.C_points || gameStateSum.C_globas ? (
                  <div className={'table-interest'}>
                    <div><p>{__('sim_consumentenbelasting')}</p></div>
                    <div><p>{gameStateSum.C_points} {__('sim_punten')}</p></div>
                    <div><p>{gameStateSum.C_globas} {__('sim_miljard')}</p></div>
                  </div>
                ) : null}
                {gameStateSum.VV_points || gameStateSum.VV_globas ? (
                  <div className={'table-interest'}>
                    <div><p>{__('sim_mensmilieubelasting')}</p></div>
                    <div><p>{gameStateSum.VV_points} {__('sim_punten')}</p></div>
                    <div><p>{gameStateSum.VV_globas} {__('sim_miljard')}</p></div>
                  </div>
                ) : null}
                {gameStateSum.V_points || gameStateSum.V_globas ? (
                  <div className={'table-interest'}>
                    <div><p>{__('sim_vermogenbelasting')}</p></div>
                    <div><p>{gameStateSum.V_points} {__('sim_punten')}</p></div>
                    <div><p>{gameStateSum.V_globas} {__('sim_miljard')}</p></div>
                  </div>
                ) : null}
                {this.getOISum(overigeInkomsten) ? (
                  <div className={'table-interest'}>
                    <div><p>{__('sim_overige_inkomsten')}</p></div>
                    <div><p></p></div>
                    <div><p>{this.getOISum(overigeInkomsten)} {__('sim_miljard')}</p></div>
                  </div>
                ) : null}
                {totalDebitCredit ? (
                  <div className={'table-interest'}>
                    <div><p>{__('sim_aflossingen_en_rentes')}</p></div>
                    <div><p></p></div>
                    <div><p>{totalDebitCredit} {__('sim_miljard')}</p></div>
                  </div>
                ) : null}
                <div className={'plus-minus'}/>
                <div className={'table-interest bold'}>
                  <div><p>{__('sim_totaal')}</p></div>
                  <div><p>{this.getTotalBudgetPoints(gameStateSum)} {__('sim_punten')}</p></div>
                  <div><p>{this.getTotalBudgetGlobas(gameStateSum, overigeInkomsten, totalDebitCredit)} {__('sim_miljard')}</p></div>
                </div>
              </ContentContainer>
            </div>
          </div>
        </div>
        <NextStep />
      </div>
    );
  }
}

export default connect(state => state)(Taxes);



// WEBPACK FOOTER //
// ./src/components/routes/Taxes.js